import React from 'react';
import DataTable from 'react-data-table-component';
import { MapPin, User, Eye, Pen, Download, FileSpreadsheet, Printer } from 'lucide-react';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import StatusTabs from '../../../common/StatusTab';
import HeaderBanner from '../../../common/HeaderBanner';
import { getLoggedUser } from '../../../../state/user';
import { getDeliverySiteList } from './services/DeliverySiteService';
import { Link } from 'react-router-dom';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import NewDropdown from '../../../common/NewDropDown';
import FilterSection from '../../../common/Filter';
import DateRangeSelector from '../../../common/DateRange';

export class DeliverySiteList extends React.Component {
    constructor() {
        super();
        this.state = {
            search: {
                group: '',
                auction: '',
                status: '',
                bidder: null,
            },
            siteVisitStatus: 'all',
            input: {},
            groups: [],
            auctions: [],
            customers: [],
            siteVisits: [],
            selectedUser: {},
            showUserPopUp: false,
            statusData: [
                { key: 'all', label: 'All', count: 0 },
                { key: 'S', label: 'Scheduled', count: 0 },
                { key: 'T', label: 'In Transit', count: 0 },
                { key: 'C', label: 'Completed', count: 0 },
                { key: 'D', label: 'Delayed', count: 0 },
            ],
            is_loading: false,
            limit: 15,
            page: 1,
            rejectNote: null,
            rejectNoteError: null,
            hideSidebar: false,
            showModal: false,
            total: 0
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleRowsPerPageChange = this.handleRowsPerPageChange.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        const params = new URLSearchParams(window.location.search);
        const search = {
            group: params.get('group') || '',
            auction: params.get('auction') || '',
            status: params.get('status') || '',
            bidder: params.get('bidder') || null,
        };
        const siteVisitStatus = params.get('siteVisitStatus');
        const page = parseInt(params.get('page')) || 1;
        const limit = parseInt(params.get('limit')) || 15;

        this.setState({ search, siteVisitStatus, page, limit }, () => {
            this.fetchDeliverySiteList();
        });
    }

    updateUrlQuery(q) {
        const queryString = new URLSearchParams(
            Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
        ).toString();
        window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
    }

    async fetchDeliverySiteList() {
        this.setState({ is_loading: true });
        let { limit, page, siteVisitStatus } = this.state;

        try {
            const filters = {
                page: page,
                per_page: limit,
            };

            if (siteVisitStatus && siteVisitStatus !== 'all') {
                filters.status = siteVisitStatus;
            }

            if (this.state.search.group) {
                filters.group_id = this.state.search.group;
            }

            if (this.state.search.auction) {
                filters.auction_id = this.state.search.auction;
            }

            if (this.state.search.bidder) {
                filters.buyer_id = this.state.search.bidder;
            }

            const response = await getDeliverySiteList(filters);

            if (response.success) {
                let siteVisits = response.data || [];
                let meta = response.meta || {};

                const statusCounts = meta.status_counts || {
                    total: 0,
                    scheduled: 0,
                    in_transit: 0,
                    completed: 0,
                    delayed: 0
                };

                this.setState({
                    siteVisits: siteVisits,
                    total: meta.total || 0,
                    statusData: [
                        { key: 'all', label: 'All', count: statusCounts.total || 0 },
                        { key: 'P', label: 'Scheduled', count: statusCounts.scheduled || 0 },
                        { key: 'T', label: 'In Transit', count: statusCounts.in_transit || 0 },
                        { key: 'C', label: 'Completed', count: statusCounts.completed || 0 },
                        { key: 'D', label: 'Delayed', count: statusCounts.delayed || 0 },
                    ],
                    is_loading: false,
                });
            } else {
                console.error('Failed to fetch delivery schedules:', response.message);
                this.setState({
                    siteVisits: [],
                    is_loading: false
                });
            }
        } catch (error) {
            console.error('Error fetching delivery schedules:', error);
            this.setState({
                siteVisits: [],
                is_loading: false
            });
        }
    }

    handleTabChange = (key) => {
        this.setState({ siteVisitStatus: key }, () => {
            this.fetchDeliverySiteList();
        });
    };

    handlePageChange(page) {
        this.setState({ page: page }, () => {
            this.fetchDeliverySiteList();
        });
    };

    handleRowsPerPageChange(newLimit) {
        this.setState({ limit: newLimit, page: 1 }, () => {
            this.fetchDeliverySiteList();
        });
    };

    handleRowClick = (row) => {
        console.log('Row clicked:', row);

        if (this.props.history && row.id) {
            this.props.history.push(`/delivery-site/edit/${row.id}`);
        }
    };


    handleEdit = (row, e) => {
        e?.stopPropagation();
        if (this.props.history && row.id) {
            this.props.history.push(`/delivery-site/edit/${row.id}`);
        }
    };

    getStatusBadge = (status) => {
        const statusMap = {
            'P': { label: 'Scheduled', color: '#3b82f6', bgColor: '#dbeafe' },
            'T': { label: 'In Transit', color: '#8b5cf6', bgColor: '#f3e8ff' },
            'C': { label: 'Completed', color: '#10b981', bgColor: '#d1fae5' },
            'D': { label: 'Delayed', color: '#f59e0b', bgColor: '#fef3c7' }
        };

        const statusInfo = statusMap[status] || { label: status, color: '#6b7280', bgColor: '#f3f4f6' };

        return (
            <span style={{
                backgroundColor: statusInfo.bgColor,
                color: statusInfo.color,
                padding: '4px 12px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: '500',
                whiteSpace: 'nowrap',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
            }}>
                <span style={{
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    backgroundColor: statusInfo.color,
                }} />
                {statusInfo.label}
            </span>
        );
    };

    getCompletionStatusBadge = (progress) => {
        let statusInfo;

        if (progress >= 100) {
            statusInfo = { label: 'Completed', color: '#10b981', bgColor: '#d1fae5' };
        } else if (progress >= 75) {
            statusInfo = { label: 'Almost Complete', color: '#8b5cf6', bgColor: '#f3e8ff' };
        } else if (progress >= 50) {
            statusInfo = { label: 'Halfway', color: '#3b82f6', bgColor: '#dbeafe' };
        } else if (progress > 0) {
            statusInfo = { label: 'In Progress', color: '#f59e0b', bgColor: '#fef3c7' };
        } else {
            statusInfo = { label: 'Not Started', color: '#6b7280', bgColor: '#f3f4f6' };
        }

        return (
            <span style={{
                backgroundColor: statusInfo.bgColor,
                color: statusInfo.color,
                padding: '4px 10px',
                borderRadius: '20px',
                fontSize: '11px',
                fontWeight: '500',
                whiteSpace: 'nowrap',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
            }}>
                {statusInfo.label}
            </span>
        );
    };

    formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    formatWeight = (weight) => {
        return parseFloat(weight || 0).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    getColumns() {
        return [
            {
                name: '#',
                selector: (row, index) => index + 1,
                width: '60px',
                center: true,
            },
            {
                name: '',
                center: true,
                width: '70px',
                cell: (row) => (
                    <div className="d-flex align-items-center justify-content-center gap-2">
                        <Link
                            className="button1 button1-primary"
                            to={`/delivery-site/edit/${row.id}`}
                            onClick={(e) => this.handleEdit(row, e)}
                        >
                            <Eye size={14} />
                        </Link>
                    </div>
                ),
            },
            {
                name: 'Project Name',
                selector: row => row.delivery_schedule?.project_name || '-',
                sortable: true,
                width: '180px',
                cell: row => (
                    <Link
                        to={`/delivery-site/edit/${row.id}`}
                        onClick={(e) => this.handleEdit(row, e)}
                    >
                        <div style={{ fontWeight: '600', color: '#1e40af' }}>
                            {row.delivery_schedule?.project_name || '-'}
                        </div>
                        <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>
                            Lot: {row.lot_ref || '-'}
                        </div>
                    </Link>
                ),
            },
            {
                name: 'Supervisor',
                selector: row => row.supervisor?.name || row.supervisor_name || '-',
                sortable: true,
                width: '130px',
                cell: row => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <User size={14} color="#6b7280" />
                        <span style={{ fontSize: '13px' }}>
                            {row.supervisor?.name || row.supervisor_name || '-'}
                        </span>
                    </div>
                ),
            },
            {
                name: 'Area',
                selector: row => row.area_place?.place_name || '-',
                sortable: true,
                width: '120px',
                cell: row => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <MapPin size={14} color="#6b7280" />
                        <span style={{ fontSize: '13px' }}>
                            {row.area_place?.place_name || '-'}
                        </span>
                    </div>
                ),
            },
            {
                name: 'Weight Progress',
                selector: row => row.progress || 0,
                sortable: true,
                width: '200px',
                cell: row => {
                    const progress = parseFloat(row.progress) || 0;
                    const loadedWeight = parseFloat(row.loaded_weight) || 0;
                    const expectedWeight = parseFloat(row.expected_weight) || 0;
                    const remainingWeight = parseFloat(row.remaining_weight) || 0;

                    return (
                        <div className="weight-progress-container">
                            <div className="progress-header" style={{ marginBottom: '6px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ fontSize: '12px', fontWeight: '600', color: '#374151' }}>
                                        {progress.toFixed(1)}%
                                    </span>
                                    <span style={{ fontSize: '11px', color: '#6b7280' }}>
                                        {this.formatWeight(loadedWeight)} / {this.formatWeight(expectedWeight)} T
                                    </span>
                                </div>
                            </div>

                            <div className="progress-bar-container" style={{ marginBottom: '6px' }}>
                                <div
                                    style={{
                                        width: '100%',
                                        height: '6px',
                                        backgroundColor: '#e5e7eb',
                                        borderRadius: '3px',
                                        overflow: 'hidden',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: `${progress}%`,
                                            height: '100%',
                                            backgroundColor: progress >= 100 ? '#10b981' :
                                                progress >= 75 ? '#8b5cf6' :
                                                    progress >= 50 ? '#3b82f6' : '#f59e0b',
                                            transition: 'width 0.3s ease',
                                        }}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                {this.getCompletionStatusBadge(progress)}
                                <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: '500' }}>
                                    {remainingWeight > 0 ? `${this.formatWeight(remainingWeight)} T left` : 'Complete'}
                                </div>
                            </div>
                        </div>
                    );
                },
            },
            {
                name: 'Load From/To',
                width: '120px',
                cell: row => (
                    <div style={{ fontSize: '12px' }}>
                        <div style={{ marginBottom: '4px' }}>
                            <div style={{ fontSize: '10px', color: '#6b7280', marginBottom: '2px' }}>From:</div>
                            <div style={{ fontWeight: '500' }}>{row.load_from || '-'}</div>
                        </div>
                        <div>
                            <div style={{ fontSize: '10px', color: '#6b7280', marginBottom: '2px' }}>To:</div>
                            <div style={{ fontWeight: '500' }}>{row.load_to || '-'}</div>
                        </div>
                    </div>
                ),
            },
            {
                name: 'Status',
                selector: row => row.status,
                sortable: true,
                width: '120px',
                cell: row => this.getStatusBadge(row.status),
            },
            {
                name: 'Dates',
                width: '120px',
                cell: row => (
                    <div style={{ fontSize: '12px' }}>
                        <div style={{ marginBottom: '4px' }}>
                            <div style={{ fontSize: '10px', color: '#6b7280', marginBottom: '2px' }}>Start:</div>
                            <div style={{ fontWeight: '500' }}>
                                {this.formatDate(row.expecting_start_date) || '-'}
                            </div>
                        </div>
                        <div>
                            <div style={{ fontSize: '10px', color: '#6b7280', marginBottom: '2px' }}>End:</div>
                            <div style={{ fontWeight: '500' }}>
                                {this.formatDate(row.expecting_end_date) || '-'}
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                name: 'Actions',
                width: '80px',
                center: true,
                cell: (row) => (
                    <div className="d-flex align-items-center justify-content-center gap-2">
                        <Link
                            className="button1 button1-primary"
                            to={`/delivery-site/edit/${row.id}`}
                            onClick={(e) => this.handleEdit(row, e)}
                        >
                            <Pen size={14} />
                        </Link>
                    </div>
                ),
            },
        ];
    }

    renderTable() {
        const { siteVisits = [], limit = 15, page = 1, total = 0 } = this.state;

        const customTableStyles = {
            ...tableStyles,
            rows: {
                ...tableStyles.rows,
                style: {
                    ...tableStyles.rows?.style,
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f8f9fa',
                    },
                },
            },
        };

        return (
            <div className="delivery-schedule-table">
                <DataTable
                    key={`${page}-${limit}`}
                    title=""
                    columns={this.getColumns()}
                    data={siteVisits}
                    customStyles={customTableStyles}
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={total}
                    paginationPerPage={limit}
                    paginationDefaultPage={page}
                    paginationRowsPerPageOptions={[15, 25, 50, 100]}
                    paginationComponentOptions={{
                        rowsPerPageText: i18n.t('rows_per_page'),
                        rangeSeparatorText: i18n.t('out'),
                    }}
                    onChangeRowsPerPage={this.handleRowsPerPageChange}
                    onChangePage={this.handlePageChange}
                    onRowClicked={this.handleRowClick}
                />
            </div>
        );
    }

    render() {
        const user = getLoggedUser();
        const { is_loading, siteVisits, siteVisitStatus, statusData } = this.state;

        return (
            <React.Fragment>
                <HeaderBanner
                    title={i18n.t('delivery_site_list')}
                    subtitle={i18n.t('manage_delivery_site_list')}
                />
                <section className="mt-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 col-lg-12 col-md-12">
                                {!this.state.hideSidebar && <SideBar />}
                            </div>
                            <div
                                className={
                                    this.state.hideSidebar
                                        ? 'col-xl-12 col-lg-12 col-md-12'
                                        : 'col-xl-9 col-lg-12 col-md-12'
                                }
                            >
                                <div className="card">
                                    <div className="card-header">
                                        <div className="expand-dashboard">
                                            <span
                                                style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                                                onClick={() => {
                                                    this.setState({
                                                        hideSidebar: !this.state.hideSidebar,
                                                    });
                                                }}
                                            >
                                                {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                                                {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                                            </span>
                                        </div>

                                        <div className="header-action">
                                            <NewDropdown
                                                label={i18n.t('overall_summary')}
                                                // loading={exportLoading}
                                                icon={Download}
                                                items={[
                                                    {
                                                        label: i18n.t('excel'),
                                                        icon: FileSpreadsheet,
                                                        // onClick: () => this.handleDownload('excel'),
                                                    },
                                                    {
                                                        label: i18n.t('pdf'),
                                                        icon: Printer,
                                                        disabled: true,
                                                    },
                                                ]}
                                            />
                                        </div>



                                    </div>

                                    <FilterSection
                                        loading={this.state.isLoading}
                                        onSearch={this.handleSearchSubmit}
                                        onClear={this.handleClearFilters}
                                    >


                                        <div className="select-wrapper floating-label-wrapper">
                                            <input
                                                id="startDate"
                                                type="date"
                                                name="startDate"
                                                value={this.state.search.startDate || ''}
                                                onChange={this.handleSearchChange}
                                                className="filter-base floating-input"
                                                placeholder=" "
                                            />
                                            <label htmlFor="startDate" className="floating-label">
                                                {i18n.t('start_date')}
                                            </label>
                                        </div>

                                        {/* End Date */}
                                        <div className="select-wrapper floating-label-wrapper">
                                            <input
                                                id="endDate"
                                                type="date"
                                                name="endDate"
                                                value={this.state.search.endDate || ''}
                                                onChange={this.handleSearchChange}
                                                className="filter-base floating-input"
                                                placeholder={i18n.t('end_date')}
                                            />
                                            <label htmlFor="endDate" className="floating-label">
                                                {i18n.t('end_date')}
                                            </label>
                                        </div>

                                        <DateRangeSelector
                                            onChange={this.handleDateRangeChange}
                                            clearTrigger={this.state.clearDate}
                                        />
                                    </FilterSection>
                                    <div className="card-body">
                                        <StatusTabs
                                            tabs={statusData}
                                            onTabChange={this.handleTabChange}
                                            selected={siteVisitStatus}
                                        />

                                        <div className="Data-Listing">
                                            {is_loading ? (
                                                <TableSkeleton columns={8} rows={10} />
                                            ) : siteVisits.length ? (
                                                this.renderTable()
                                            ) : (
                                                <NoData
                                                    message="No delivery schedules available"
                                                    actionText="Refresh"
                                                    onAction={this.fetchDeliverySiteList.bind(this)}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}